import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { CallPermissionView } from '@gem/call/popups/Permissions/Shared/CallPermissionView/CallPermissionView';

import { useCallMemberPermissionPresenter } from './CallMemberPermission.presenter';
import { ICallMemberPermissionProps } from './CallMemberPermission.types';

export const CallMemberPermission: FC<ICallMemberPermissionProps> = observer((props) => {
  const presenter = useCallMemberPermissionPresenter(props);

  return (
    <CallPermissionView
      permissionValue={presenter.permissionValue}
      permissionLabel={presenter.permissionLabel}
      onClick={presenter.onClick}
    />
  );
});
